module.exports = __webpack_public_path__ + "static/media/approval_handover_request.d0823c99.svg";